import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { PageLoader } from '@/components/ui/Spinner';

interface AdminGuardProps {
  children: React.ReactNode;
}

export const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const location = useLocation();
  const { isAdminAuthenticated, isLoading, hasHydrated } = useAuthStore();

  // Wait for Zustand to hydrate from localStorage
  if (!hasHydrated || isLoading) {
    return <PageLoader message="Verificando credenciais de admin..." />;
  }

  if (!isAdminAuthenticated) {
    // Redirect to admin login page with return URL
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AdminGuard;
